module Meevo.Plugins.Client {
    "use strict";
    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;
    import Location = Meevo.Model.Location;
    import NounEnum = Meevo.Model.NounEnum;
    import VerbEnum = Meevo.Model.VerbEnum;
    import SortDirection = Meevo.Model.SortDirection;
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import IClientDiscountHistory = Meevo.Model.IClientDiscountHistory;
    import SaleStateEnum = Meevo.Model.SaleStateEnum;    

    interface ITransactionHistoryFilters {
        saleTypeEnum?: SalesTypeEnum;
        locationId?: number;
        isGlobal: boolean;
        filterLastTwoYears: boolean;
        StartDate?: Date;
        endDate?: Date;
    }

    interface ITransactionHistoryRequest {
        criteria?: ITransactionHistoryFilters;
        clientGlobalId?: Guid;
        sortDirection: SortDirection;
        itemsPerPage: number;
    }

    enum PrintTypeEnum {
        Receipt,
        GiftReceipt,
        InsuranceReceipt
    }

    enum TabViewEnum {
        TransactionView,
        DiscountView
    }

    export class TransactionHistorySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {
        public historyTransaction: IDataMaintenanceInfiniteList;
        public historyDiscount: IDataMaintenanceInfiniteList;       
        public request: ITransactionHistoryRequest = {
            itemsPerPage: 25,
            sortDirection: SortDirection.Descending,
            criteria: {
                isGlobal: true,
                filterLastTwoYears: false                

            }
        };
        public locations: Array<Location>;
        public itemTypeDisplay = {
            [SalesTypeEnum.Service]: 'S',
            [SalesTypeEnum.ServiceCancellationFee]: 'S',
            [SalesTypeEnum.ServiceNoShowFee]: 'S',
            [SalesTypeEnum.Product]: 'P',
            [SalesTypeEnum.GiftCard]: 'GC',
            [SalesTypeEnum.Package]: 'PKG',
            [SalesTypeEnum.Membership]: 'MEM',
            [SalesTypeEnum.MembershipPayment]: 'EFT',
            [SalesTypeEnum.MembershipRenewal]: 'EFT',
            [SalesTypeEnum.MembershipWaive]: 'EFT'
        };
        public discountTypeDisplay = {
            [DiscountTypeEnum.SpecialPrice]: 'LABEL_SPECIAL_PRICE',
            [DiscountTypeEnum.AmountOff]: 'LABEL_AMOUNT_OFF',
            [DiscountTypeEnum.PercentOff]: 'LABEL_PERCENT_OFF',
            [DiscountTypeEnum.BuyGet]: 'LABEL_BUY_ONE_GET_ONE'
        };
        public itemTypes = [
            {
                salesTypeEnum: SalesTypeEnum.Service,
                identifier: this.itemTypeDisplay[SalesTypeEnum.Service],
                label: 'SERVICES'
            },
            {
                salesTypeEnum: SalesTypeEnum.Product,
                identifier: this.itemTypeDisplay[SalesTypeEnum.Product],
                label: 'HEADER_PRODUCTS'
            },
            {
                salesTypeEnum: SalesTypeEnum.GiftCard,
                identifier: this.itemTypeDisplay[SalesTypeEnum.GiftCard],
                label: 'LABEL_GIFT_CARDS'
            },
            {
                salesTypeEnum: SalesTypeEnum.Package,
                identifier: this.itemTypeDisplay[SalesTypeEnum.Package],
                label: 'LABEL_PACKAGES'
            },
            {
                salesTypeEnum: SalesTypeEnum.Membership,
                identifier: this.itemTypeDisplay[SalesTypeEnum.Membership],
                label: 'HEADER_MEMBERSHIPS'
            }
        ];

        public selectedTab: TabViewEnum;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $cookies: angular.cookies.ICookiesService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected recentClientsService: Meevo.Plugins.Client.RecentClientsService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings,sectionSecurityKey);
        }

        /**
         * Trigger for tab selection
         */
        selected(): void {
            super.selected();
            this.selectedTab = TabViewEnum.TransactionView;
            this.historyTransaction = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `${this.baseEndpoint}/${this.parentItemId}/${this.sectionEndpoint}`);
            this.historyDiscount = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `${this.baseEndpoint}/${this.parentItemId}/discountHistory`, (pageNumber: number, items: Array<IClientDiscountHistory>) => {
                items.forEach((item: IClientDiscountHistory) => {
                    if (item.discountTypeEnum === DiscountTypeEnum.PercentOff) {
                        item['displayDiscountValue'] = item.discountValue * 100 + "%"
                    }
                })
            });
            
            this.historyTransaction.getItemAtIndex = this.fetchItemAtIndex;

            this.request.clientGlobalId = this.parentItemId;
            this.filter();

            this.busyService.start();
            this.dataService.customMethodData('api/location/list', 'POST', {
                criteria: {
                    filterBySessionUser: true,
                    zipCode: ''
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
                itemsPerPage: 100000,
                pageNumber: 0,
                sortBy: '',
                sortDirection: Meevo.Model.SortDirection.Ascending
            })
                .then((response) => {
                    this.locations = response.data;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Apply current filter
         */
        applyFilter(): void {
          this.filter();
          this.usageTrackingLog(Meevo.Model.NounEnum.ClientTransactionHistory, Meevo.Model.VerbEnum.ApplyButtonClicked);
        }

        /**
         * Do filtering
         */
        filter(): void {
            let request: ITransactionHistoryRequest = angular.copy(this.request);

            if (!this.request.criteria.locationId) {
                request.criteria.locationId = this.identityService.current().locationId;
                request.criteria.isGlobal = true;
            } else {
                request.criteria.isGlobal = false;
            }

            if (this.selectedTab === TabViewEnum.TransactionView) {
                this.historyTransaction.initSearch(request);
            } else if (this.selectedTab === TabViewEnum.DiscountView) {
                request.criteria.filterLastTwoYears = false;
                this.historyDiscount.initSearch(request);
            }
        }

        /**
         * Open selected transaction in Transaction Editor
         * @param {string} transactionNumber
         * @param {number} locationId
         */
        openTransactionEditor(transactionNumber: string, locationId: number): void {
            if (!transactionNumber || transactionNumber === "N/A") return;
            
            if (locationId !== this.identityService.locationId) {
                this.modalService.alert("MESSAGE_TRANSACTION_AT_ANOTHER_LOCATION", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            
            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,                    
            });
        }

        /**
         * Print receipt
         * item
         * {PrintTypeEnum} printType
         */
        print(item: any, printType: PrintTypeEnum): void {
            if (item.transactionNumber && item.transactionGuid) {
                this.busyService.start();
                var showCopy = true;
                var receiptUrl: string = `/api/Sale/${item.transactionNumber}/${PrintTypeEnum[printType]}`;
                if (printType === PrintTypeEnum.InsuranceReceipt) {
                    receiptUrl += "/List";
                    showCopy = false;
                }
                this.printService.printCustom({ 
                    url: receiptUrl, 
                    method: "GET", 
                    params: { 
                        showCopy: showCopy, 
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT
                    } 
                }).then((returnData) => {
                    return this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.PrintReceiptButtonClicked, null, item.transactionGuid);
                }).finally(() => {
                    this.busyService.stop();
                });
            }
        }

        /**
         * Email receipt
         * item
         * {PrintTypeEnum} printType
         */
        email(item: any, printType: PrintTypeEnum): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/client/sectionViews/selectEmail.modal.html',
                controller: 'meevo.plugins.client.SelectEmailController',
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    email: this.recentClientsService.clientEmail
                }
            }

            this.modalService.showCustom(options).then(selectedEmail => {
                switch (printType) {
                    case PrintTypeEnum.Receipt:
                        this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.SaleCreated, null, selectedEmail, true);
                        break;
                    case PrintTypeEnum.GiftReceipt:
                    this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.GiftReceiptCreated, null, selectedEmail, true);
                        break;
                    case PrintTypeEnum.InsuranceReceipt: 
                        let saleDate = moment(item.saleDate).format("YYYYMMDD").toString(),
                            data = saleDate + item.saleId,
                            params = this.appSettings.APP_COUNTRYID,
                            url = `/${this.appSettings.API_ROOT}/Sale/${data}`;

                        this.dataService.customMethodData(url, "GET", data, params).then((response) => {
                            let sales = response.data;

                            if (sales != null && sales.saleLines != null) {
                                let clients = sales.saleLines.map(saleLine => saleLine.clientId),
                                    clientsToProcess = clients.filter((item, index, inputArray) => inputArray.indexOf(item) == index);

                                for (var clientId of clientsToProcess) {
                                    this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.InsuranceReceiptCreated, clientId, selectedEmail, false);
                                }
                            };
                        });
                        break;
                }
            });
        }

        /**
         * Sends email notifications based on types i.e. Sale Created (receipt) , Gift Receipt created (gift receipt), insurance receipt
         * @param transItem
         * @param type
         * @param clientId
         */
        receiptNotification(transItem: any, type: Meevo.Model.CommunicationTypeEnum, clientId: any, selectedEmail: string, showCopy: boolean = false) {
            let saleDate = moment(transItem.saleDate).format("YYYY-MM-DD").toString(),
                communicationType = type,
                communicationMethod = Meevo.Model.CommunicationMethodEnum.Email,
                saleid = parseInt(transItem.saleId),
                data;

            if (clientId != null) {
                clientId = clientId.toString();
            }

            data = {
                id: saleid,
                emailId: selectedEmail,
                saleId: saleid,
                saleDate: saleDate,
                communicationType: communicationType,
                communicationMethod: communicationMethod,
                clientId: clientId,
                showCopy: showCopy,
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT
            }

            if (saleid) {
                let url = `/${this.appSettings.API_ROOT}/Sale/${saleid}/Notification`;

                this.busyService.start();
                this.dataService.customMethodData(url, "POST", data).then((response) => {
                }).finally(() => {
                    this.busyService.stop();
                });
            }
        }

        /**
         * Track Usage
         * @param {NounEnum} nounEnum
         * @param {VerbEnum} verbEnum
         */
        usageTrackingLog(nounEnum: NounEnum, verbEnum: VerbEnum): void {
            let trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, this.parentItemId);

            this.trackingService.saveTrackingInfo(trackingItem);
        }

        get printTypeEnum(): any {
            return PrintTypeEnum;
        }

        get tabViewEnum(): any {
            return TabViewEnum;
        }

        get nounEnum(): any {
            return NounEnum;
        }

        get saleStateEnum(): any {
            return SaleStateEnum;
        }

        get discountTypeEnum(): any {
            return DiscountTypeEnum;
        }

        /**
        * Select tab
        * @param {TabViewEnum} tab
        */
        selectTab(tab: TabViewEnum, nounEnum: NounEnum): void {
            this.selectedTab = tab;
            this.usageTrackingLog(nounEnum, VerbEnum.Viewed);
            this.filter();
        }

        fetchItemAtIndex = function (index) {
            let itemPage = {};
            let pageNumber = Math.floor(index / this.requestPage.itemsPerPage);
            let page = this.loadedPages[pageNumber];

            if (this.loadedPages.length >= 0) {
                let stop;

                this.loadedPages.forEach((item, i) => {
                    if (stop || !item) { return; }

                    if (index > item.length - 1) {
                        index = index - item.length;
                    } else {
                        itemPage = item[index];
                        stop = true;
                    }
                });
            }

            if (!_.isEmpty(itemPage)) {
                return itemPage;
            } else if (!page) {
                this.fetchMoreItems(pageNumber);
            }
        }
    }
}